import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { CustomAccordionNav } from '../shared/material_components';
import LocalStoragePreferences from '../utils/local-storage-preferences';
import SidenavSection from './sidenav-section';
import type { SystemAppIds } from './sidenav-helpers';
import type { NavLinks } from './sidenav-links';

interface Props {
  links: NavLinks;
  hasMemberships: boolean;
  systemAppIds: SystemAppIds;
}

const Container = styled(Box)({
  width: 225,
  overflow: 'auto',
  position: 'absolute',
  top: 53,
  bottom: 0,
  paddingRight: 1,
});

const localStorageInstance = new LocalStoragePreferences();

export default ({
  links: {
    platform, appSetup, setup, organization,
  }, hasMemberships, systemAppIds,
}: Props) => {
  const isSetupOpen = localStorageInstance.isSidenavSetupOpen();
  const shouldHaveSetup = !!setup?.length || !!appSetup?.length || !!organization?.length;
  const [isOpen, setIsOpen] = useState(isSetupOpen);

  const handleOnChange = () => {
    localStorageInstance.set('sidenav:setup:open', !isOpen);
    setIsOpen(!isOpen);
  };

  return (
    <Container>
      <SidenavSection
        title=""
        links={platform || []}
        systemAppIds={systemAppIds}
      />
      { shouldHaveSetup && (
        <CustomAccordionNav
          TransitionProps={{ unmountOnExit: true }}
          onChange={handleOnChange}
          sectionKey={isOpen ? 'true' : ''}
          label="Setup"
        >
          {!!setup?.length && (
            <SidenavSection
              title="Configuration"
              links={setup}
              systemAppIds={systemAppIds}
            />
          )}
          {!!appSetup?.length && (
            <SidenavSection
              title="App Setup"
              links={appSetup}
              systemAppIds={systemAppIds}
            />
          )}
          {hasMemberships && !!organization?.length && (
            <SidenavSection
              title="Organization"
              links={organization}
              systemAppIds={systemAppIds}
            />
          )}
        </CustomAccordionNav>
      )}
    </Container>
  );
};
